import { render, staticRenderFns } from "./ModalHojaAdmision.vue?vue&type=template&id=2f6da846&"
import script from "./ModalHojaAdmision.vue?vue&type=script&lang=js&"
export * from "./ModalHojaAdmision.vue?vue&type=script&lang=js&"
import style0 from "./ModalHojaAdmision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports